<template>
  <v-flex mb-0 xs12 mx-2>
    <v-layout row justify-start mx-3 mt-3 align-center>
      <div class="text-xs-left" style="font-sze: 20px; font-weight: 600;">Data Access Service Info</div>
    </v-layout>

    <v-form v-model="valid" @submit="editDataAccessService" ref="editDataAccessServiceForm">
      <v-layout grid-list-md justify-start pa-0 ma-0 mr-0 pr-0 mt-2>
        <v-layout hide-details justify-start row mt-0 mb-2>
          <!-- Left Column of Fields -->
          <v-flex hide-details mx-4 xs4>
            <v-text-field
              style="max-height: 45px"
              v-model="service.CircuitNumber"
              label="Circuit #*"
              required
              maxlength="20"
              :rules="requiredRules"
            ></v-text-field>
            <!-- <v-text-field
              style="max-height: 45px"
              v-model="service.RTN"
              label="Ring-to Telephone #*"
              mask="(###) ###-####"
              :rules="rtnRules"
            ></v-text-field>-->
            <v-autocomplete
              hide-details
              :items="ddlCircuitType"
              v-model="service.CircuitType"
              item-text="Text"
              item-value="Value"
              label="Circuit Type*"
              required
              :rules="requiredRules"
              @change="updatedCircuitType"
            ></v-autocomplete>
            <v-autocomplete
              hide-details
              :items="ddlClassOfService"
              v-model="service.ClassOfService"
              item-text="Text"
              item-value="Value"
              label="Class Of Service*"
              required
              :rules="requiredRules"
            ></v-autocomplete>
            <v-autocomplete
              hide-details
              :items="ddlConnectionType"
              v-model="service.ConnectionType"
              item-text="Text"
              item-value="Value"
              label="Connection Type*"
              required
              :rules="requiredRules"
            ></v-autocomplete>
            <v-text-field
              style="max-height: 45px"
              v-model="service.CircuitDescription"
              label="Circuit Description"
              maxlength="30"
            ></v-text-field>
          </v-flex>
          <!-- Center Column of Fields -->
          <v-flex hide-details mx-4 xs4>
            <v-text-field
              style="max-height: 45px"
              v-model="service.MonthlyRate"
              label="Monthly Rate*"
              :rules="monthlyRateRules"
            ></v-text-field>
             <v-text-field style="max-height: 45px" v-model="service.IPAddress" label="IP Address" maxlength="20"></v-text-field>
            <v-text-field style="max-height: 45px" v-model="service.DomainName" label="Domain Name" maxlength="20"></v-text-field>
          </v-flex>
          <!-- Right Column of Fields -->
          <v-flex hide-details mx-4 xs4>
            <!-- <v-text-field
              style="max-height: 45px"
              v-model="service.BillPrintText"
              value="BillPrintText"
              label="Bill Print Text"
              maxlength="25"
            ></v-text-field>-->
            <v-text-field
              style="max-height: 45px"
              v-model="service.ContractNumber"
              label="Contract Number*"
              required
              maxlength="20"
              :rules="requiredRules"
            ></v-text-field>
            <v-menu
              v-model="menu"
              :close-on-content-click="true"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                style="max-height: 44px"
                slot="activator"
                v-model="service.ContractDate"
                label="Contract Date*"
                prepend-inner-icon="fa-calendar-alt"
                readonly
                clearable
                required
                :rules="requiredRules"
              ></v-text-field>
              <v-date-picker v-model="service.ContractDate" @input="menu = false"></v-date-picker>
            </v-menu>

            <v-autocomplete
              hide-details
              :items="ddlSalesIds"
              v-model="service.SalesId"
              value="SalesId"
              label="Sales ID*"
              required
              :rules="requiredRules"
              item-text="Text"
              item-value="Value"
            ></v-autocomplete>
            <v-autocomplete
              style="margin-top: 55px;"
              hide-details
              :items="ddlActionRequest"
              v-model="service.ActionRequest"
              item-text="Text"
              item-value="Value"
              clearable
              required
              :rules="requiredRules"
            >
              <template slot="label">
                <div class="red--text">Service Action*</div>
              </template>
            </v-autocomplete>
          </v-flex>
        </v-layout>
      </v-layout>
      <v-layout row hide-details justify-start ml-4 mt-0 mb-0>
        <v-checkbox label="Use Service Point Address?" v-model="showSPAddress"></v-checkbox>
      </v-layout>
      <v-layout row hide-details justify-start mt-0 mb-4 v-if="showSPAddress">
        <servicePointAddress
          v-if="showSPAddress"
          ref="componentSPAddress"
          :ServicePointAddress="service.ServicePointAddress ? service.ServicePointAddress : {}"
        ></servicePointAddress>
      </v-layout>
      <v-layout hide-details justify-end row mt-0 mb-4>
        <v-btn color="success" @click="editDataAccessService()" class="ml-2 mr-4">Edit</v-btn>
      </v-layout>
    </v-form>
  </v-flex>
</template>

<script>
import axios from "axios";
import Bus from "../../bus";
import servicePointAddress from "./ServicePointAddress.vue";

export default {
  name: "EditVoiceAccessService",
  props: [
    "accountNumber",
    "elementType",
    "elementDescription",
    "serviceType",
    "providerId",
    "serviceId"
  ],
  components: {
    servicePointAddress
  },
  watch: {
    "service.ClassOfService": async function(val) {
      if (val) {
       this.isClassOfServiceLoaded += await 1;
          var getConnectionTypeDDL = await this.getConnectionTypeDDL();
      }
    }
  },
  async mounted() {
    var GetEditServiceInfo = await axios
      .get("api/Services/GetEditServiceInfo/" + this.serviceId)
      .then(async res => {
        this.service = await res.data;
        this.ddlActionRequest = await res.data.ddlActionRequest;
        if (this.service.ContractDate) {
          this.service.ContractDate = this.service.ContractDate.split("T")[0];
        }
        if (this.service.CircuitType) {
          this.service.CircuitType = this.service.CircuitType.toString();
        }
        if (this.service.ClassOfService) {
          this.service.ClassOfService = this.service.ClassOfService.toString();
        }
        if (this.service.ConnectionType) {
          this.service.ConnectionType = this.service.ConnectionType.toString();
        }
        if (this.service.MonthlyRate == 0){
          this.service.MonthlyRate = this.service.MonthlyRate.toString()
        }
        this.service.ActionRequest = "ZZ";
      });
    if (this.service.ServicePointAddress) {
      this.showSPAddress = true;
    }

    var getCircuitTypeDDL = await this.getCircuitTypeDDL();
    var getClassOfServiceDDL = await this.getClassOfServiceDDL();
    var getConnectionTypeDDL = await this.getConnectionTypeDDL();
    // Populate Sales Ids DDL
    axios
      .get("/api/Services/GetSalesIdDDL")
      .then(response => {
        this.ddlSalesIds = response.data;
        if (this.ddlSalesIds.length === 1) {
          this.service.SalesId = this.ddlSalesIds[0].Value;
        }
      })
      .catch(error => {
        console.log(error);
      });
  },

  data() {
    return {
      service: { ClassOfService: null },
      valid: true,
      menu: false,
      menu1: false,
      showSPAddress: false,
      isClassOfServiceLoaded: 0,

      //radio yes no
      radYesNo: [
        { text: "YES", value: "1" },
        { text: "NO", value: "0" }
      ],
      // Drop down list variables
      ddlCircuitType: [],
      ddlClassOfService: [],
      ddlConnectionType: [],
      ddlSalesIds: [],
      ddlActionRequest: [],

      // Form validation Rules
      monthlyRateRules: [
        v => !!v || "",
        v =>
        new RegExp("^\\d+(?:\\.\\d{0,2})?$").test(v) ||
        "Must be in currency format"
      ],
      
      requiredRules: [v => !!v || ""]
    };
  },

  methods: {
    async editDataAccessService() {
      if (this.$refs.editDataAccessServiceForm.validate()) {
        if (this.showSPAddress) {
          this.service.ServicePointAddress = await this.$refs.componentSPAddress
            .servicePointAddress;
        } else {
          if (this.service.ServicePointAddress) {
            delete this.service.ServicePointAddress;
          }
        }
        axios
          .post("/api/Services/EditDataAccessService", this.service)
          .then(res => {
            
            Bus.$emit("alert", {
              color: "success",
              message: "Service Edited Successfully!"
            });
            this.$emit("close");
          })
          .catch(err => {
            console.log(err);

            Bus.$emit("alert", {
              color: "error",
              message: "An Error Occured while Creating Service."
            });
          });
      }
    },
    async getCircuitTypeDDL() {
      // Populate Circuit Type DDL
      await axios
        .get(
          "/api/Services/GetCircuitTypeDDL/" +
            this.serviceType +
            "/" +
            this.providerId
        )
        .then(async response => {
          this.ddlCircuitType = await response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    async getClassOfServiceDDL() {
      // Populate Class Of Service DDL
      await axios
        .get("/api/Services/GetClassOfServiceDDL/" + this.service.CircuitType)
        .then(async response => {
          this.ddlClassOfService = await response.data;
          if (this.isClassOfServiceLoaded >2) {
            if (this.ddlClassOfService.length > 0) {
              this.service.ClassOfService = this.ddlClassOfService[0].Value;
            }
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    async getConnectionTypeDDL() {
      // Populate Connection Type DDL
      await axios
        .get(
          "/api/Services/GetConnectionTypeDDL/" + this.service.ClassOfService
        )
        .then(async response => {
          this.ddlConnectionType = await response.data;
         
          if (this.isClassOfServiceLoaded > 2) {
            if (this.ddlConnectionType.length > 0) {
              this.service.ConnectionType = this.ddlConnectionType[0].Value;
            }
          }
        })
        .catch(error => {
          console.log(error);
        });
      return true;
    },
    async updatedCircuitType(val) {
      if (val) {
        this.isClassOfServiceLoaded+= await 1
        this.getClassOfServiceDDL();
      }
    }
  }
};
</script>